// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userDetails-container {
  width: 100%;
  height: auto;
  padding: 8px;
}

.userDetailsHeading {
  font-weight: bold;
  color: white;
  font-size: 1.75rem;
}

.userDetailsTabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
}

.userDetailsTab {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 1.25rem;
  font-weight: bold;
  color: #247a97;

  .admin-user-table-header {
    background-color: #e2e2e2;
    font-size: 1.5rem;
  }
}

.tabActive {
  background-color: #e2e2e2;
  border-radius: 4px;
  font-size: 2rem;
}

.tabFalse {
  background-color: #f3f4f6;
  border-radius: 4px;
  font-size: 1.75rem;
}

.userDetails-container .orders-table-header {
  font-size: 1.5rem;
}

.usersCartTotalItems,
.usersCartTotalPrice {
  font-size: 1.5rem;
  margin-top: 0.5rem;
  font-weight: bold;
}

.cart-details-header {
  width: 100%;
  margin-top: 1.5rem;
}

.users-cart-details thead {
  font-size: 1.75rem;
  background-color: #e2e2e2;
}

.userDetailsCardBody tr {
  justify-content: center;
  text-align: left;
}

.userDetailsCardBody td {
  font-size: 1.25rem;
}

.userDetailsCard {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  border-radius: 8px;
}

.userDetailsCardBody {
  padding: 16px;
  gap: 1rem;
}

.orders-table-header th,
.cart-details-header th,
.reviews-details-header th {
  font-size: 1.5rem;
  background-color: #e2e2e2;
  color: #247a97;
}

.reviews-details-header th {
  text-align: center;
}

.userLineItemDetails {
  margin-top: 1rem;
}

.userDetails-container .userLineItemDetails:nth-child(4) td {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/UserDetails.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;;EAEd;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".userDetails-container {\n  width: 100%;\n  height: auto;\n  padding: 8px;\n}\n\n.userDetailsHeading {\n  font-weight: bold;\n  color: white;\n  font-size: 1.75rem;\n}\n\n.userDetailsTabs {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  background-color: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n}\n\n.userDetailsTab {\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #247a97;\n\n  .admin-user-table-header {\n    background-color: #e2e2e2;\n    font-size: 1.5rem;\n  }\n}\n\n.tabActive {\n  background-color: #e2e2e2;\n  border-radius: 4px;\n  font-size: 2rem;\n}\n\n.tabFalse {\n  background-color: #f3f4f6;\n  border-radius: 4px;\n  font-size: 1.75rem;\n}\n\n.userDetails-container .orders-table-header {\n  font-size: 1.5rem;\n}\n\n.usersCartTotalItems,\n.usersCartTotalPrice {\n  font-size: 1.5rem;\n  margin-top: 0.5rem;\n  font-weight: bold;\n}\n\n.cart-details-header {\n  width: 100%;\n  margin-top: 1.5rem;\n}\n\n.users-cart-details thead {\n  font-size: 1.75rem;\n  background-color: #e2e2e2;\n}\n\n.userDetailsCardBody tr {\n  justify-content: center;\n  text-align: left;\n}\n\n.userDetailsCardBody td {\n  font-size: 1.25rem;\n}\n\n.userDetailsCard {\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 16px;\n  border-radius: 8px;\n}\n\n.userDetailsCardBody {\n  padding: 16px;\n  gap: 1rem;\n}\n\n.orders-table-header th,\n.cart-details-header th,\n.reviews-details-header th {\n  font-size: 1.5rem;\n  background-color: #e2e2e2;\n  color: #247a97;\n}\n\n.reviews-details-header th {\n  text-align: center;\n}\n\n.userLineItemDetails {\n  margin-top: 1rem;\n}\n\n.userDetails-container .userLineItemDetails:nth-child(4) td {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
